<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/msi_logo.svg" width="125" height="21" alt="MSI Logo">
        <img class="navbar-brand-minimized" src="img/brand/msi_sun_flat.svg" width="30" height="30" alt="MSI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <h6 class="d-none d-sm-block mb-0">Welcome {{ $kauth.idTokenParsed.given_name }}</h6>
        <MSIHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SiteDropdown class="m-2"/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main d-flex">
        <div class="container-fluid d-flex m-0 p-0" style="flex: 0 0 100%;">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!-- <component :is="asideComponent"></component> -->
      </AppAside>
    </div>
    <TheFooter id="msiFooter">
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a class="link-highlight" href="http://morgansolar.com">Morgan Solar Inc</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav';
import {
  Aside as AppAside,
  AsideToggler,
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Footer as TheFooter
} from '@coreui/vue';
import MSIHeaderDropdownAccnt from './MSIHeaderDropdownAccnt';
import SiteDropdown from '../components/SiteDropdown';

export default {
  name: 'msicustom',
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    AsideToggler,
    TheFooter,
    MSIHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    SiteDropdown
  },
  data() {
    return {
      nav: nav.items
    };
  },
  computed: {
    asideComponent(){
      return this.$store.state.asideComponent;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  }
};
</script>
